import { Card, CardTitle } from "@/components/ui/Card";
import { EverbayLogo } from "@/components/ui/EverbayLogo";

function MaintenanceLottieAnimation() {
  return (
    <div
      aria-hidden
      className="pointer-events-none relative -z-10 mx-auto -mb-4 w-full max-w-3xl lg:-mb-7 xl:-mb-9"
    >
      <iframe
        className="m-0 aspect-[380/300] h-auto w-full border-none p-0"
        src="https://lottie.host/embed/f428e961-0c2a-40b7-9692-82b0d7d39b45/CHUXmWcPRB.json"
      />
    </div>
  );
}

function MaintenanceCard() {
  return (
    <Card className="isolate flex flex-col gap-y-4 overflow-hidden">
      <CardTitle>Wartungsarbeiten</CardTitle>
      <div className="flex flex-col items-center justify-center gap-y-4">
        <EverbayLogo className="size-12" isColored />
        <h1 className="text-center text-4xl/tight font-semibold">
          Wir sind bald wieder für Sie da
        </h1>
        <p className="max-w-prose text-center leading-relaxed">
          Derzeit werden Wartungsarbeiten an der everbay App durchgeführt. Unser
          System ist in Kürze wieder verfügbar. Bei Fragen wenden Sie sich bitte
          an unser Service-Team.
        </p>
        <MaintenanceLottieAnimation />
      </div>
    </Card>
  );
}

export { MaintenanceCard };
